// AddUser.js

import React, { useState, useEffect } from 'react';
import './AddUser.css';

const AddUser = ({ fetchWithAuth }) => {
  const [newUsername, setNewUsername] = useState('');
  const [newUserGroupId, setNewUserGroupId] = useState('');
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUserGroup = async () => {
      const username = localStorage.getItem('username'); // Retrieve the username from local storage or another source
      if (!username) {
        console.error("Username not found.");
        return;
      }

      const newToken = localStorage.getItem('token');
      try {
        const response = await fetchWithAuth(`${process.env.REACT_APP_FQDN}/api/user-group-info`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${newToken}`, // Include the token in the Authorization header
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username }), // Send username in request body
        });

        const data = await response.json();
        setGroups(data.group ? [data.group] : []); // Set groups as an array containing the group info
      } catch (error) {
        console.error("Error fetching user group:", error);
      }
    };
    fetchUserGroup();
  }, [fetchWithAuth]);

  const handleAddUser = async () => {
    if (!newUsername || !newUserGroupId) {
      alert('All fields are required');
      return;
    }

    const newToken = localStorage.getItem('token');
    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_FQDN}/api/add-user`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${newToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: newUsername,
          group_id: newUserGroupId,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setUsers([...users, { username: newUsername, group_id: newUserGroupId }]);
        setNewUsername('');
        setNewUserGroupId('');
        alert(`User '${newUsername}' added successfully!`);
      } else {
        alert(`Failed to add user: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error adding user:', error);
      alert('Error adding user');
    }
  };

  return (
    <div className="admin-add-user">
      <h3>Add New User</h3>
      <div className="add-user-column-admin">
        <input
          type="text"
          value={newUsername}
          onChange={(e) => setNewUsername(e.target.value)}
          placeholder="Enter username"
          autoComplete="new-username"
          className="register-input"
        />
        <select
          value={newUserGroupId}
          onChange={(e) => setNewUserGroupId(e.target.value)}
          autoComplete="off"
          className="register-input"
        >
          <option value="" disabled>
            Select Group
          </option>
          {Array.isArray(groups) ? (
            groups.map((group) => (
              <option key={group.group_id} value={group.group_id}>
                {group.group_name}
              </option>
            ))
          ) : (
            groups && (
              <option key={groups.group_id} value={groups.group_id}>
                {groups.group_name}
              </option>
            )
          )}
        </select>
        <button onClick={handleAddUser} className='register-input'>Add User</button>
      </div>
    </div>
  );
};

export default AddUser;
